var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48534 9.04167C0.665009 9.04167 0 9.69458 0 10.5C0 11.3054 0.66501 11.9583 1.48534 11.9583H9.47222V19.5C9.47222 20.3284 10.1562 21 11 21C11.8438 21 12.5278 20.3284 12.5278 19.5L12.5278 11.9583H20.5147C21.335 11.9583 22 11.3054 22 10.5C22 9.69458 21.335 9.04167 20.5147 9.04167H12.5278V1.5C12.5278 0.671573 11.8438 0 11 0C10.1562 0 9.47222 0.671573 9.47222 1.5L9.47222 9.04167H1.48534Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.4a08a2e4c4ab2fb92e343c3761ac9d9c.svg";
export { ForwardRef as ReactComponent };